<template>
    <div>
        <!-- 图片 -->
        <div class="bg">
            <div class="sub-title">Contact us</div>
            <!-- <div class="title" >联系我们</div> -->
        </div>
        <div class="p-3">
            <div class="flex-row justify-center align-center">
                <div>
                    <div class="namse">
                        FJ CONTROLLING CO.,LTD.
                    </div>
                    <div class="namseaa">
                        <p>Head office：Building E,<br/> No. 48 Dongfu Road, SIP</p>
                        <p>Nationwide Service Locations：<br/>shanghai/hefei/chongqing/<br/>zhaoqing/beijing/xuzhou</p>
                        <p>Contact information：+86 512 6767 8902</p>
                        <p>7-day-24-hour hotline：<br/> 400 873 0588</p>
                    </div>
                </div>
                <div style="display: flex;flex-direction: column;justify-content: space-between;">
                    <div></div>
                    <div class="" style="display: flex;flex-direction: column;align-items: center;">
                        <div style="width: 100px;height: 100px;">
                            <img src="../../assets/img/code.jpg" style="width: 100%;height: 100%;" alt="">
                        </div>
                        <div style="font-size: 12px;">Welcome to follow our WeChat</div>
                    </div>
                </div>
            </div>
            <!-- 项目咨询 -->
            <div class="mt-3">
                <div class="flex-row justify-between align-center">
                    <div>
                        <div class="sub-title">Project consulting</div>
                        <!-- <div class="title">项目咨询</div> -->
                    </div>
                    <div>
                        <!-- <img src="@/assets/mimg/more.png" alt="" style="width: 100px;"> -->
                        <div class="sub-title" @click="projectSubmit()">submit</div>
                    </div>
                </div>
                <div class="mt-1 flex-row flex-wrap justify-between">
                    <div style="margin-top: 10px;">
                        <div class="flex-row flex-wrap">
                            <div class="project-item flex-row align-center" v-for="item in projectData" style="width: 100%;">
                                <div style="margin-right: 20px;" class="input-name">{{ item.name }}</div>
                                <div>
                                    <el-input placeholder="Please enter content" @blur="judgeEmpty(item)" :class="{inputEmpty:item.error}" v-model="item.value" clearable>
                                    </el-input>
                                    <div v-if="item.name == 'Phone' && !item.validPhone" class="error-tip">The phone format is incorrect.</div>
                                    <div v-if="item.name == 'Mail' && !item.checkEmail" class="error-tip">The mailbox format is incorrect.</div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="flex-row justify-end" style="padding-bottom: 30px;">
                            <a href="mailto:salse@fjctrl.com?subject=项目咨询&body=公司:xxx;行业：xxx;" class="btn">提交</a>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="mt-3">
                <div class="flex-row justify-between align-center">
                    <div>
                        <div class="sub-title">Join us</div>
                        <!-- <div class="title">加入我们</div> -->
                    </div>
                    <div>
                        <!-- <img src="@/assets/mimg/more.png" alt="" style="width: 100px;"> -->
                        <div class="sub-title" @click="projectSubmit1()">submit</div>
                    </div>
                </div>
                <div class="mt-1 flex-row flex-wrap justify-between">
                    <div style="margin-top: 10px;">
                        <div class="flex-row flex-wrap">
                            <div class="project-item flex-row align-center" v-for="item in projectData1" style="width: 100%;">
                                <div style="margin-right: 20px;" class="input-name">{{ item.name }}</div>
                                <div>
                                    <el-input placeholder="Please enter content" @blur="judgeEmpty(item)" :class="{inputEmpty:item.error}" placeholder-style="font-size:10rpx" v-model="item.value" clearable>
                                    </el-input>
                                </div>
                            </div>
                            <div class="project-item flex-row align-center" style="width: 100%;">
                                <div class="input-name" style="margin-right: 20px;">resume</div>
                                <div style="width: 100%;">
                                    <!-- <textarea rows="10" cols="30" style="width: 100%;" class="input"></textarea> -->
                                    <el-input type="textarea" @blur="judgeEmpty(Data)" :class="{inputEmpty:Data.error}" placeholder="Please enter content" v-model="Data.value" maxlength="1000"
                                        show-word-limit></el-input>
                                </div>
                            </div>

                            <div class="project-item flex-row align-center" style="width: 100%;" >
                                <div style="width: 100px; margin-right: 10px;" class="input-name" >Attachment</div>
                                <div style="width: 100%;">
                                    <!-- <textarea rows="10" cols="30" style="width: 100%;" class="input"></textarea>
                                    //"http://10.168.13.42:9999/api/FJ_DevDataConfig/UploadOneFile" -->
                                    <el-upload
                                    class="upload-demo"
                                    :action="uploadAction"
                                    :on-preview="handlePreview"
                                    :on-remove="handleRemove"
                                    :on-success="handleSuccess"
                                    :before-remove="beforeRemove"
                                    :limit="1"
                                    :on-exceed="handleExceed"
                                    :file-list="fileList">
                                    <el-button size="small" type="primary">Click Upload</el-button>
                                    <div slot="tip" class="el-upload__tip">No more than 4M</div>
                                    </el-upload>
                                </div>
                            </div>

                        </div>
                        <!-- <div class="flex-row justify-end" style="padding-bottom: 30px;">
                            <a href="mailto:salse@fjctrl.com?subject=项目咨询&body=公司:xxx;行业：xxx;" class="btn">提交</a>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from '../../api/http';

export default {
    data() {
        return {
            value:"",
            textarea: "",
            projectData:[
                {
                    name:'Company',
                    value:"",
                    error:false
                },
                {
                    name:'Industry',
                    value:"",
                    error:false
                },
                {
                    name:'Name',
                    value:"",
                    error:false
                },
                {
                    name:'Phone',
                    value:"",
                    error:false,
                    validPhone: true
                },
                {
                    name:'Mail',
                    value:"",
                    error:false,
                    checkEmail: true
                },
                {
                    name:'Position',
                    value:"",
                    error:false
                }
            ],
            projectData1: [
                {
                    'name': 'Name',
                    'value':'',
                    error:false
                },
                {
                    'name': 'specialty',
                    'value':'',
                    error:false
                },
                {
                    'name': 'Desired position',
                    'value':'',
                    error:false
                },
                {
                    'name': 'Age',
                    'value':'',
                    error:false
                },
                {
                    'name': 'School',
                    'value':'',
                    error:false
                },
                {
                    name:'Phone',
                    value:"",
                    error:false,
                    validPhone: true
                }
            ],
            Data:{
                'name': 'resume',
                    'value':'',
                    error:false

            },
            fileList: [],
            filePath:"",
            uploadAction:http.httpIpAddress+"api/FJ_DevDataConfig/UploadOneFile"
        }
    },
    methods: {
        page(url) {
            this.$router.push('/' + url);
        },
        projectSubmit(){
            debugger

            for (let item of this.projectData) {
                this.judgeEmpty(item);}

            let projectConsult={};
                let checkResult=true;
                this.projectData.forEach(item => {
                    if(item.value==null||item.value==""){
                        item.error=true;
                        checkResult=false;
                    }else{
                        item.error=false;
                    }
                });
                
                if(!checkResult){
                    return false;
                }
                projectConsult.company=this.projectData[0].value;
                projectConsult.industry=this.projectData[1].value;
                projectConsult.name=this.projectData[2].value;
                projectConsult.telephone=this.projectData[3].value;
                projectConsult.mail=this.projectData[4].value;
                projectConsult.position=this.projectData[5].value;
                projectConsult.enable=0;
                projectConsult.creator="guangwang";
                let that=this;
                this.http.post("/api/FJ_ProjectConsult/AddProjectConsult",JSON.stringify(projectConsult)).then((result)=>{
                debugger
                let objResult= eval(result);
                let iCode= objResult.code;
                if(iCode==0){

                    
                        this.$confirm('提交成功' , '提示' , {
                            confirmButtonText:'确认',
                            type:'warning',
                            showCancelButton: false
                            // 重要，设置为true才会把右上角X和取消区分开来            
                            // closeOnClickModal: false
                        }).then(()=>{
                            this.projectData[0].value="";
                            this.projectData[1].value="";
                            this.projectData[2].value="";
                            this.projectData[3].value="";
                            this.projectData[4].value="";
                            this.projectData[5].value="";
                        })
                
                }
                else{
                    that.$message({
                    title:'失败',
                    message:'...失败',
                    type:'fail',
                    duration:2000
                })
                }
            });
            // window.open("mailto:sales@fjctrl.com?subject=项目咨询&body=公司:"+this.projectData[0].value+";行业:"+this.projectData[1].value+";姓名:"+this.projectData[2].value+";电话:"+this.projectData[3].value+";职位:"+this.projectData[5].value);
           // window.open("mailto:"+emailTo+'?cc='+emailCC+'&subject='+emailSub+'&body='+emailBody);

        },
        projectSubmit1(){
            debugger
            // window.open("mailto:fjkjhr@fjctrl.com?subject=加入我们&body=姓名:"+this.projectData1[0].value+";专业:"+this.projectData1[1].value+";期望职位:"+this.projectData1[2].value+"简历:"+this.Data.value);
           // window.open("mailto:"+emailTo+'?cc='+emailCC+'&subject='+emailSub+'&body='+emailBody);
           let joinUs={};
                let checkResult=true;
                this.projectData1.forEach(item => {
                    if(item.value==null||item.value==""){
                        item.error=true;
                        checkResult=false;
                    }else{
                        item.error=false;
                    }
                });
                
                if(this.Data.value==null||this.Data.value==""){
                    this.Data.error=true;
                    checkResult=false;
                }
                
                if(!checkResult){
                    return false;
                }
                if(this.filePath!=null&&this.filePath!=""){
                    joinUs.mail=this.filePath;
                }
                joinUs.name=this.projectData1[0].value;
                joinUs.major=this.projectData1[1].value;
                joinUs.position=this.projectData1[2].value;
                joinUs.ettribute1=this.projectData1[3].value;
                joinUs.ettribute2=this.projectData1[4].value;
                joinUs.ettribute3=this.projectData1[5].value;
                joinUs.description=this.Data.value;
                joinUs.enable=0;
                joinUs.creator="guangwang";
                let that=this;
                this.http.post("/api/FJ_JoinUs/AddJoinUs",JSON.stringify(joinUs)).then((result)=>{
                debugger
                let objResult= eval(result);
                let iCode= objResult.code;
                if(iCode==0){
                        this.$confirm('提交成功' , '提示' , {
                            confirmButtonText:'确认',
                            type:'warning',
                            showCancelButton: false
                            // 重要，设置为true才会把右上角X和取消区分开来            
                            // closeOnClickModal: false
                        }).then(()=>{
                            this.projectData1[0].value="";
                            this.projectData1[1].value="";
                            this.projectData1[2].value="";
                            this.projectData1[3].value="";
                            this.projectData1[4].value="";
                            this.projectData1[5].value="";
                            this.Data.value="";
                            that.fileList=[];
                            that.filePath="";
                        })
                
                }
                else{
                    that.$message({
                    title:'失败',
                    message:'...失败',
                    type:'fail',
                    duration:2000
                })
                }
            });
        },
         judgeEmpty(item){
            debugger


            if (item.name === 'Phone') {
        const re = /^(\+\d{1,4})?(\d{8,11})$/;
        item.validPhone = re.test(item.value);
      } else if (item.name === 'Mail') {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        item.checkEmail = re.test(item.value);
      }
      item.error = item.value === "";

            if (item.value == "") {
        item.error = true;
    } else {
        item.error = false;
        if (item.name == "Mail") {
            let regExp = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
            item.checkEmail = regExp.test(item.value);
        }
    }

            if(item.value==null||item.value==""){
                item.error=true;
            }else{
                item.error=false;
            }
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
            this.fileList=[];
            this.filePath="";
        },
        handlePreview(file) {
            console.log(file);
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        handleSuccess(response,file,fileList){
            debugger
            if(response.code==0){
                this.$message.success('上传成功!')
                this.fileList=fileList;
                this.filePath=response.data;
            }
            else{
                this.$message.success('上传失败!')
            }
        }
    }
}
</script>

<style scoped>
.inputEmpty{
    border:1px solid red;
}

.bg {
    background: url('../../assets/img/contactbanner.jpg') no-repeat;
    background-size: 100% ;
    height: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.sub-title {
    display: inline-block;
    background-color: #0AA00A;
    color: #fff;
    border-radius: 5px;
    border-top-right-radius: 0;
    font-size: 12px;
    padding: 2px 5px;
}

.title {
    font-size: 20px;
    font-weight: 700;
    margin-top: 5px;
}
.mt-3 {
    margin-top: 15px;
}
.p-3 {
    padding: 10px;
}

.namse {
    font-size: 16px;
    font-weight: 700;
}

.namseaa {
    font-size: 14px;
    margin-top: 10px;
}
.input {
    border-radius: 10px;
    padding: 5px;

}
.input-name {
    width: 50px;
}
/* .input-name::after {
    content: '* ';
    color: red;
} */

.project-item {
    width: 48%;
    margin-bottom: 10px;
    margin-right: 2px;
}
</style>


// WEBPACK FOOTER //
// src/views/contact/m_index.vue